/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_TitleInputs */

const en_csv_to_json_ref_title = /** @type {(inputs: Csv_To_Json_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the parser does with each input`)
};

const ko_csv_to_json_ref_title = /** @type {(inputs: Csv_To_Json_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파서가 각 입력에 대해 하는 일`)
};

const ja_csv_to_json_ref_title = /** @type {(inputs: Csv_To_Json_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーサが各入力に対して行うこと`)
};

/**
* | output |
* | --- |
* | "What the parser does with each input" |
*
* @param {Csv_To_Json_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_title = /** @type {((inputs?: Csv_To_Json_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_title(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_title(inputs)
	return ja_csv_to_json_ref_title(inputs)
});